import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsListProps {
  items: NewsItem[];
  title?: string;
  description?: string;
}

function newsTarget(item: NewsItem): string {
  if (item.relatedFilm) return `/detail/film/${item.relatedFilm}`;
  if (item.relatedActor) return `/detail/actor/${item.relatedActor}`;
  return `/search?q=${encodeURIComponent(item.tag)}`;
}

export default function NewsList({
  items,
  title = "最新影视资讯",
  description = "按发布时间汇总的行业动态与作品消息，掌握影视圈的第一手资讯。",
}: NewsListProps) {
  return (
    <section className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
            {title}
          </h2>
          <p className="mt-2 text-sm text-foreground-500">{description}</p>
        </div>
      </div>

      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 divide-y divide-background-200 overflow-hidden">
        {items.map((item) => (
          <Link
            key={item.id}
            to={newsTarget(item)}
            className="group flex flex-col sm:flex-row gap-3 sm:gap-6 p-4 md:p-5 hover:bg-background-100 transition-colors"
          >
            <div className="sm:w-28 shrink-0">
              <span className="inline-flex items-center gap-1 px-2 h-6 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                {item.tag}
              </span>
              <p className="mt-2 text-xs text-foreground-400">{item.date}</p>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-bold text-base text-foreground-950 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {item.summary}
              </p>
            </div>
            <span className="self-center w-8 h-8 flex items-center justify-center rounded-full text-foreground-400 group-hover:text-accent-600 transition-colors">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}